import { render, staticRenderFns } from "./branchForm.vue?vue&type=template&id=28862f74&scoped=true&"
import script from "./branchForm.vue?vue&type=script&lang=js&"
export * from "./branchForm.vue?vue&type=script&lang=js&"
import style0 from "./branchForm.vue?vue&type=style&index=0&id=28862f74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28862f74",
  null
  
)

export default component.exports